import { formatInTimeZone } from "date-fns-tz"
import { useEffect, useRef } from "react"
import ReactQuill from "react-quill"
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks"
import { removeQuotes } from "../../lib/types"
import { colors } from "../../ui/color"
import { ArrivalIcon } from "../../ui/icons/arrivalsIcon"
import { ClockIcon } from "../../ui/icons/clockIcon"
import { DeparturesIcon } from "../../ui/icons/departuresIcon"
import Button from "../../ui/molecoles/button"
import { Calendar } from "../../ui/molecoles/calendar"
import EditorInput from "../../ui/molecoles/editorInput"
import { InputComponent } from "../../ui/molecoles/input"
import { Spinner } from "../../ui/molecoles/spinner"
import { FormRow } from "../../ui/organisms/formRow/formRow"
import { findByIdReport, refreshReport, setRefreshReportStatus, setUpdateReportEmail, setUpdateReportFirstName, setUpdateReportLastName, setUpdateReportPhone, setUpdateReportReport } from "./slice"

export function FlightAnalysis() {
    const dispatch = useAppDispatch()
    const reportState = useAppSelector(state => state.report)

    const quillRef = useRef<ReactQuill>(null)

    useEffect(() => {
        if (reportState.refreshReportStatus === "successfully") {
            dispatch(findByIdReport(reportState.reportId))
            dispatch(setRefreshReportStatus("idle"))
        }
    }, [reportState.refreshReportStatus])

    useEffect(() => {
        if (reportState.findByIdStatus === "successfully") {
            dispatch(setUpdateReportEmail(reportState.findByIdResponse?.email))
            dispatch(setUpdateReportFirstName(reportState.findByIdResponse?.first_name))
            dispatch(setUpdateReportLastName(reportState.findByIdResponse?.last_name))
            dispatch(setUpdateReportPhone(reportState.findByIdResponse?.phone))
            dispatch(setUpdateReportReport(reportState.findByIdResponse?.report))
        }
    }, [reportState.findByIdStatus])

    if (reportState.updateReportStatus === "loading" ||
        reportState.findByIdStatus === "loading" ||
        reportState.refreshReportStatus === "loading"
    ) {
        return (
            <div className={"flex justify-center items-center"}>
                <Spinner />
            </div>
        )
    }

    return (
        <div className={"flex flex-col gap-5"}>
            <FormRow
                label="Flight date"
                children={[
                    <Calendar
                        label=""
                        startDate={reportState.findByIdResponse?.flight_info.flight.departure.flight_gate_times.scheduled_out_tz!}
                        setStartDate={() => undefined}
                        type={"date"}
                        disabled
                    />
                ]}
            />
            <FormRow
                label="Route"
                children={[
                    <>
                        <InputComponent
                            key={"departure-airport-name"}
                            type={"text"}
                            placeholder="Departure airport"
                            value={reportState.findByIdResponse?.flight_info.flight.departure.airport.name}
                            disabled
                            startIcon={<DeparturesIcon size={20} color={colors.neutral[700]} />}
                        />
                        <InputComponent
                            key={"arrival-airport-name"}
                            type={"text"}
                            placeholder="Arrival airport"
                            value={reportState.findByIdResponse?.flight_info.flight.arrival.airport.name}
                            disabled
                            startIcon={<ArrivalIcon size={20} color={colors.neutral[700]} />}
                        />
                    </>
                ]}
            />
            <FormRow
                label="Departure time and arrival time"
                children={[
                    <>
                        <InputComponent
                            defaultValue={reportState.findByIdResponse && formatInTimeZone(reportState.findByIdResponse?.flight_info.flight.departure.flight_gate_times.scheduled_out_tz, reportState.findByIdResponse.flight_info.flight.departure.airport.timezone, "HH:mm") + " " + reportState.findByIdResponse?.flight_info.flight.departure.airport.timezone_abbr}
                            type={"text"}
                            disabled
                            label=""
                            startIcon={<ClockIcon color={colors.neutral[500]} size={20} />}
                        />
                        <InputComponent
                            defaultValue={reportState.findByIdResponse && formatInTimeZone(reportState.findByIdResponse?.flight_info.flight.arrival.flight_gate_times.scheduled_in_tz, reportState.findByIdResponse?.flight_info.flight.arrival.airport.timezone, "HH:mm") + " " + reportState.findByIdResponse?.flight_info.flight.arrival.airport.timezone_abbr}
                            type={"text"}
                            disabled
                            label=""
                            startIcon={<ClockIcon color={colors.neutral[500]} size={20} />}
                        />
                    </>
                ]}
            />
            {/* <FormRow
                label="Flight status"
                children={[
                    reportState.findByIdResponse?.flight_info.flight.history.diverted ?
                        <Pills
                            size={"md"}
                            label={"Diverted"}
                            outline={false}
                            emphasis={true}
                            color={"red"}
                        /> :
                        reportState.findByIdResponse?.flight_info.flight.history.cancelled ?
                            <Pills
                                size={"md"}
                                label={"Canceled"}
                                outline={false}
                                emphasis={true}
                                color={"red"}
                            /> :
                            reportState.findByIdResponse?.flight_info.flight.history.blocked ?
                                <Pills
                                    size={"md"}
                                    label={"Blocked"}
                                    outline={false}
                                    emphasis={true}
                                    color={"red"}
                                /> :
                                formatDelay(reportState.findByIdResponse?.flight_info.flight.arrival.flight_gate_times.arrival_delay!)?.includes("early") ?
                                    <Pills
                                        size={"md"}
                                        label={"Landed"}
                                        outline={false}
                                        emphasis={true}
                                        color={"green"}
                                    /> :
                                    <Pills
                                        size={"md"}
                                        label={"Delayed"}
                                        outline={false}
                                        emphasis={true}
                                        color={"orange"}
                                    />
                ]}
            /> */}
            <FormRow
                label="Report analysis"
                children={[
                    <div className="flex flex-col w-full justify-start items-start">
                        <EditorInput
                            id={"flight-report"}
                            value={removeQuotes(reportState.updateReportRequest?.report!)}
                            onChangeText={(e) => dispatch(setUpdateReportReport(e))}
                            placeholder="Report analysis"
                            ref={quillRef}
                        />
                        {
                            reportState.findByIdResponse?.report === "" &&
                            <Button
                                size={"md"}
                                iconPosition={"off"}
                                variant={"link"}
                                color={"blue"}
                                label="Regenerate analysis"
                                onClick={() => dispatch(refreshReport(reportState.findByIdResponse?.id!))}
                            />
                        }
                    </div>
                ]}
            />
            {/* <FormRow
                label={"Nome e Cognome"}
                children={[
                    <>
                        <InputComponent
                            type={"text"}
                            placeholder="Nome"
                            value={reportState.updateReportRequest?.first_name}
                            onChangeText={(text) => dispatch(setUpdateReportFirstName(text))}
                        />
                        <InputComponent
                            type={"text"}
                            placeholder="Cognome"
                            value={reportState.updateReportRequest?.last_name}
                            onChangeText={(text) => dispatch(setUpdateReportLastName(text))}
                        />
                    </>
                ]}
            />
            <FormRow
                label={"Email e Telefono"}
                children={[
                    <>
                        <InputComponent
                            type={"text"}
                            placeholder="Email"
                            value={reportState.updateReportRequest?.email}
                            onChangeText={(text) => dispatch(setUpdateReportEmail(text))}
                        />
                        <InputComponent
                            type={"text"}
                            placeholder="Telefono"
                            value={reportState.updateReportRequest?.phone}
                            onChangeText={(text) => dispatch(setUpdateReportPhone(text))}
                        />
                    </>
                ]}
            /> */}
        </div>
    )
}